import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import { environment } from '../../../../../environments/environment';
import * as XLSX from 'xlsx';

@Component({
	selector: 'app-report-list-container',
	templateUrl: './report-list-container.component.html',
	styleUrls: ['./report-list-container.component.css']
})
export class ReportListContainerComponent implements OnInit {

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	public displayColumns: any[];
	public displayHeaders: any[];
	public listData: any[] = [];
	public openingBalance: number;
	public showOpeningBalance: boolean;
	public isExporting = false;
	dataSource = new MatTableDataSource<any>(this.listData);

	constructor(
		public speaker: SpeakerService,
		private snackbar: SnackbarService,
		private http: HttpClient,
		private cookie: CookieService,
	) { }

	ngOnInit(): void {
		this.listData = this.speaker.listData
		this.displayHeaders = this.speaker.displayHeaders;
		this.displayColumns = this.speaker.displayColumns;
		this.dataSource = new MatTableDataSource<any>(this.listData);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.openingBalance = this.speaker.openingBalance;
		this.showOpeningBalance = this.speaker.showOpeningBalance;
	}

	public doFilter = (event: Event) => {
		var value = (event.target as HTMLInputElement).value;

		if (typeof value === 'string') {
			this.dataSource.filter = value.trim().toLocaleLowerCase();
		}
	}

	public exportToExcel(): void {
		const backend = this.speaker.exportBackend;

		if (!backend && (!this.dataSource.filteredData || this.dataSource.filteredData.length === 0)) {
			this.snackbar.warning('No data to export');
			return;
		}

		this.isExporting = true;

		if (backend) {
			this.downloadFromBackend(backend);
			return;
		}

		setTimeout(() => {
			try {
				const exportData = this.dataSource.filteredData.map(row => {
					const exportRow: any = {};
					this.displayColumns.forEach((col, i) => {
						exportRow[this.displayHeaders[i]] = row[col];
					});
					return exportRow;
				});

				const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
				const wb: XLSX.WorkBook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, 'Report');

				const colWidths = this.displayHeaders.map((header: string) => {
					const maxLen = Math.max(
						header.length,
						...exportData.map(row => String(row[header] || '').length)
					);
					return { wch: Math.min(maxLen + 2, 50) };
				});
				ws['!cols'] = colWidths;

				const timestamp = new Date().toISOString().slice(0, 10);
				XLSX.writeFile(wb, `report_${timestamp}.xlsx`);
				this.snackbar.success('Report exported successfully');
			} catch (err) {
				this.snackbar.error('Failed to export report');
			} finally {
				this.isExporting = false;
			}
		}, 50);
	}

	private downloadFromBackend(backend: { model: string; route: string; payload: any; filename: string }): void {
		const url = `${environment.api}${backend.model}${backend.route}`;
		const headers: any = { Authorization: this.cookie.get('session-key') };
		this.http.post(url, backend.payload, { headers, responseType: 'blob' }).subscribe({
			next: (blob: Blob) => {
				const objectUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = objectUrl;
				link.download = backend.filename || 'Report.xlsx';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(objectUrl);
				this.snackbar.success('Report exported successfully');
				this.isExporting = false;
			},
			error: () => {
				this.snackbar.error('Failed to export report');
				this.isExporting = false;
			}
		});
	}
}


